import { WindowType } from '@/features/product-configurator/types';

export const MOCK_PRODUCTS: WindowType[] = [
  {
    id: 'standard',
    name: 'Standard Window',
    description: 'Standard sash window configuration',
    imageUrl: '🪟',
    basePrice: 299,
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'vents', 'glazing', 'addons', 'optional-extras'],
    order: 1,
  },
  {
    id: 'arch',
    name: 'Arch Window',
    description: 'Sliding sash with decorative arch top - Arch subtype required',
    imageUrl: '🏛️',
    basePrice: 629,
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 2,
  },
  {
    id: 'coupled_2',
    name: 'Coupled Window - 2 Windows',
    description: 'Two windows coupled together with 6mm clips (1 pair included)',
    imageUrl: '🔗',
    basePrice: 620,
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'vents', 'glazing', 'addons', 'optional-extras'],
    order: 3,
  },
  {
    id: 'coupled_3',
    name: 'Coupled Window - 3 Windows',
    description: 'Three windows coupled together with 6mm clips (2 pairs included)',
    imageUrl: '🔗🔗',
    basePrice: 941,
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'vents', 'glazing', 'addons', 'optional-extras'],
    order: 4,
  },
  {
    id: 'coupled_4',
    name: 'Coupled Window - 4 Windows',
    description: 'Four windows coupled together with 6mm clips (3 pairs included)',
    imageUrl: '🔗🔗🔗',
    basePrice: 1262,
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'vents', 'glazing', 'addons', 'optional-extras'],
    order: 5,
  },
  {
    id: 'bay_box_3',
    name: 'Bay Window - Box Bay (3 Windows)',
    description: 'Box bay configuration with 3 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 6,
  },
  {
    id: 'bay_box_4',
    name: 'Bay Window - Box Bay (4 Windows)',
    description: 'Box bay configuration with 4 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 7,
  },
  {
    id: 'bay_box_5',
    name: 'Bay Window - Box Bay (5 Windows)',
    description: 'Box bay configuration with 5 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 8,
  },
  {
    id: 'bay_splayed_3',
    name: 'Bay Window - Splayed Bay (3 Windows)',
    description: 'Splayed bay configuration with 3 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 9,
  },
  {
    id: 'bay_splayed_4',
    name: 'Bay Window - Splayed Bay (4 Windows)',
    description: 'Splayed bay configuration with 4 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 10,
  },
  {
    id: 'bay_splayed_5',
    name: 'Bay Window - Splayed Bay (5 Windows)',
    description: 'Splayed bay configuration with 5 windows',
    imageUrl: '🏠',
    basePrice: 0, // TBC - Price to be confirmed
    isActive: true,
    categories: ['measurements', 'colors', 'cills', 'hardware', 'security', 'decorative', 'glazing', 'addons', 'optional-extras'],
    order: 11,
  },
];
